import styled from "styled-components";

export const ProfileButtonEmailTitleStyled = styled.div`
    padding-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: var(--color-label-primary);    
`;

